import { ReactNode, useEffect, useMemo, useState } from "react";

import Filters from "components/Filters";
import FiltersContentWrapper from "components/Filters/ContentWrapper";
import FiltersSidebar from "components/Filters/Sidebar";
import FiltersSplit from "components/Filters/Split";
import useTypedFlags from "hooks/useTypedFlags";

import {
  FILTER_TYPE,
  FILTERS_ORDER_SETTINGS_KEY,
  INTEGRATIONS_FILTERS,
  INTEGRATIONS_FILTERS_ONLY_CATEGORIES,
} from "../../constants";
import { createIntegrationsFiltersOptionsMap } from "../../helpers";
import { IntegrationView } from "../../types";

type FiltersLayoutProps = {
  children: ReactNode;
  titleId: string;
  integrations: IntegrationView[];
};

const FiltersLayout = ({ children, titleId, integrations }: FiltersLayoutProps) => {
  const [loading, setLoading] = useState<boolean>(true);
  const { useIntegrationsCounts, intentNewLayout } = useTypedFlags();

  // workaround. Filters relies on an API request setting the loading state to false on
  // the second render, but we don't have an API request here.
  useEffect(() => {
    setLoading(false);
  }, []);

  const INTEGRATIONS_FILTERS_OPTIONS_MAP = useMemo(
    () => createIntegrationsFiltersOptionsMap(integrations, useIntegrationsCounts, { intentNewLayout }),
    [integrations, useIntegrationsCounts, intentNewLayout]
  );

  return (
    <Filters
      filters={useIntegrationsCounts ? INTEGRATIONS_FILTERS : INTEGRATIONS_FILTERS_ONLY_CATEGORIES}
      filtersItemsOptionsMap={INTEGRATIONS_FILTERS_OPTIONS_MAP}
      filtersLoading={loading}
      sortOptions={[]}
      initialSortDirection={null}
      initialSortOption={null}
      pollActiveSections={() => undefined}
      filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
      filtersType={FILTER_TYPE}
      disableViews
    >
      <FiltersSplit>
        <FiltersSidebar />
        <FiltersContentWrapper titleId={titleId}>{children}</FiltersContentWrapper>
      </FiltersSplit>
    </Filters>
  );
};

export default FiltersLayout;
